import ApiError from "./ApiError";

export default class SignInInvalidUsernameError extends ApiError{
}